const CardComponent = ({ title, children }) => {
    return (
        <div className="card rounded-0">
            <div className="card-body">
                <h5 className="card-title">{title}</h5>
                {children}
            </div>
        </div>
    );
};

export default CardComponent;